<template>

    <div>

        <transition name="modal">
            <v-modal-tag-delete v-if="showModal === 'delete-' + tag.id" :tag="tag" @deleted="$emit('deleted')" />
        </transition>

        <v-list-item>
            <div class="d-flex align-items-center">
                <v-swatch class="mr-15" :size="20" :color="tag.color" />
                <div>
                    <span><a href="#" @click.prevent="selectTag">{{ tag.name }}</a></span><br>
                    <span class="small" v-if="tag.description">{{ tag.description }}</span>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-end">
                <span class="small text-muted mr-15">Created {{ tag.created_at | date }}</span>
                <v-button-toolbar size="sm">
                    <v-button size="sm" btn-style="secondary" @click.native="selectTag">Edit</v-button>
                    <v-dropdown
                        type="secondary"
                        label="More"
                        :items="[
                            { key: 'delete', value: 'Delete Tag' },
                        ]"
                        :show-selected="false"
                        :menu-right="true"
                        @change="onActionSelected">
                    </v-dropdown>
                </v-button-toolbar>
            </div>
        </v-list-item>

    </div>

</template>

<script>

import ModalTagDelete from '@modals/tag/ModalTagDelete';

export default {

    components: {
        'v-modal-tag-delete': ModalTagDelete,
    },

    props: {
        tag: {
            type: Object,
            required: true,
        },
    },

    methods: {

        onActionSelected(item) {
            if (item.key === 'delete') {
                this.$store.commit('showModal', 'delete-' + this.tag.id);
            }
        },

        selectTag() {
            this.$router.push({
                name: 'tags-edit',
                params: { id: this.tag.id },
            });
        },

    },

}

</script>